import { useBaseStore } from '../../base';

export const useSessionInfo = () => {
	const { sessionInfo } = useBaseStore();

	return sessionInfo;
};
